import React from "react";
import { CustomComponentCustomFormField, CustomFormSelection, MatrixRadioButtonsFormField } from "../../../../../amorg-common";
import { AnswerFieldContext } from "../../customFormFieldFactory";
import { RiskAssessmentHelper } from "./_components/RiskAssessmentHelper";

type Kim3RiskAssessmentCustomFormFieldComponentProps = AnswerFieldContext & {
    field:CustomComponentCustomFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Kim3RiskAssessmentCustomFormFieldComponent(props:Kim3RiskAssessmentCustomFormFieldComponentProps):JSX.Element
{
    const timepointsField = props.answer.selections.find(s => s.fieldId === 'timepoints');
    const timepoints = parseNumberValue(timepointsField);

    let appliedForceNumericalValue = 0;
    const appliedForceAnswerField = props.answer.selections.find(s => s.fieldId === 'appliedForce');
    const appliedForceValue = appliedForceAnswerField.value;
    const appliedForceFormField = props.form.fields.find(f => f.fieldId === 'appliedForce') as MatrixRadioButtonsFormField;
    if(!appliedForceFormField)
        throw new Error('Missing field in form with fieldId = "appliedForce"');
    const appliedForceOptions = appliedForceFormField.sections.flatMap((s => s.rows.flatMap(r => r.options))).filter(o => o !== null);
    const selectedOption = appliedForceOptions.find(o => o.value === appliedForceValue);
    if(selectedOption)
        appliedForceNumericalValue = selectedOption.numericalValue || 0;

    const forceTransferField = props.answer.selections.find(s => s.fieldId === 'forceTransfer');
    const forceTransfer = parseNumberValue(forceTransferField);
    
    const positionMovementField = props.answer.selections.find(s => s.fieldId === 'positionMovement');
    const positionMovement = parseNumberValue(positionMovementField);
    
    const workOrganizationField = props.answer.selections.find(s => s.fieldId === 'workOrganization');
    const workOrganization = parseNumberValue(workOrganizationField);
    
    const workConditionsField = props.answer.selections.find(s => s.fieldId === 'workConditions');
    const workConditions = parseNumberValue(workConditionsField);
    
    const workPostureField = props.answer.selections.find(s => s.fieldId === 'workPosture');
    const workPosture = parseNumberValue(workPostureField);

    const riskField = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
    const risk = parseNumberValue(riskField);

    const newRiskAssessmentValue = (appliedForceNumericalValue+forceTransfer+positionMovement+workOrganization+workConditions+workPosture) * timepoints;
    const oldRiskAssessmentValue = risk || 0;

    React.useEffect(() => {
        const updateRiskAssessment = async (value:number) => {
            await props.onSubmit([{ fieldId:props.field.fieldId, value:value.toString()}]);
            props.doUpdate();
        };

        if(newRiskAssessmentValue !== oldRiskAssessmentValue)
        {
            updateRiskAssessment(newRiskAssessmentValue);
        }

    }, [timepoints, appliedForceNumericalValue, forceTransfer, positionMovement, workOrganization, workConditions, workPosture]);
    
    return (
        <RiskAssessmentHelper
            {...props}
            riskAssessmentField={props.field}
            sumElements={[
                { text:'Type kraftanvendelse i finger-/håndområdet', value:appliedForceNumericalValue },
                { text:'Kraftoverføring/<br/>Grebsforhold', value:forceTransfer },
                { text:'Hånd-/armposition og bevægelse', value:positionMovement },
                { text:'Arbejdsorganisation', value:workOrganization },
                { text:'Arbejdsforhold', value:workConditions },
                { text:'Arbejdsstilling', value:workPosture },
            ]}
            factorElements={[
                { text:'Tidspoint', value:timepoints },
            ]}
            document="kim3"
            
        />
    );
}

function parseNumberValue(field:CustomFormSelection):number | null
{
    if(field === null)
        return null;

    if(isNaN(parseFloat(field.value)))
        return null;

    return parseFloat(field.value);
}